import {
  Dialog,
  DialogContent,
  DialogContentText,
  Link as MUILink,
} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import DialogTitle from '../DialogTitle.jsx';

const Link = props => (
  <MUILink
    underline="always"
    sx={{
      color: 'text.primary',
    }}
    {...props}
  />
);

const Text = props => (
  <DialogContentText
    sx={{
      color: 'text.primary',
      display: 'block',
      marginBottom: 2,
    }}
    {...props}
  />
);

const TermsDialog = ({open, onClose}) => {
  return (
    <Dialog open={open} onClose={onClose} size="sm" fullWidth>
      <DialogTitle title="Terms" onClose={onClose} />
      <DialogContent>
        <Text>
          <Link
            href="https://www.planet.com/terms-of-use/"
            target="_blank"
            rel="noreferrer noopener"
          >
            Terms of Use
          </Link>
        </Text>
        <Text>
          <Link
            href="https://www.planet.com/privacy/"
            target="_blank"
            rel="noreferrer noopener"
          >
            Privacy Policy
          </Link>
        </Text>
        <Text>
          © {new Date().getFullYear()} Planet for the PlanetScope (Dove),
          SkySat, Tanager, Pelican, and RapidEye satellite imagery.
        </Text>
        <Text>
          ©
          <Link
            href="https://www.mapbox.com/about/maps/"
            target="_blank"
            rel="noreferrer noopener"
          >
            Mapbox
          </Link>{' '}
          ©
          <Link
            href="http://www.openstreetmap.org/copyright"
            target="_blank"
            rel="noreferrer noopener"
          >
            OpenStreetMap
          </Link>{' '}
          for the labels, borders, and roads overlay, if applicable.
        </Text>
      </DialogContent>
    </Dialog>
  );
};

TermsDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default TermsDialog;
